module.exports = __webpack_public_path__ + "static/media/schedule.f8279e2d.svg";